import { X } from "lucide-react";
import { getContentRightsText } from "@crewcast/shared";

interface ContentRightsModalProps {
  companyName: string;
  onClose: () => void;
}

export default function ContentRightsModal({
  companyName,
  onClose,
}: ContentRightsModalProps) {
  const termsText = getContentRightsText(companyName);

  return (
    <div
      className="crewcast-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="content-rights-title"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      onKeyDown={(e) => {
        if (e.key === "Escape") onClose();
      }}
      tabIndex={-1}
    >
      <div className="crewcast-modal-card" style={{ maxWidth: "640px" }}>
        <div className="crewcast-modal-header">
          <div>
            <h2 id="content-rights-title" className="crewcast-modal-title">
              Content Release Terms
            </h2>
          </div>
          <button
            type="button"
            className="crewcast-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>

        <div className="crewcast-modal-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
          <pre
            style={{
              whiteSpace: "pre-wrap",
              fontFamily: "var(--font-primary)",
              fontSize: "var(--font-size-sm)",
              lineHeight: "1.6",
              margin: 0,
              color: "var(--color-gray-700)",
            }}
          >
            {termsText}
          </pre>
        </div>

        <div className="crewcast-modal-actions">
          <button
            type="button"
            className="crewcast-modal-btn primary"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
